var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HelperViewStatus,{staticClass:"handle-error",attrs:{"title":"Houve um problema ao carregar as informações","description":"Aguarde um momento e tente novamente.","button-label":"Tentar novamente","status":"alert"},on:{"click":_setup.fetchInitialData}})
}
var staticRenderFns = []

export { render, staticRenderFns }